module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.20.0@babel-runtime/core-js/symbol/iterator.js
 ** module id = 676
 ** module chunks = 0
 **/